module.exports = __webpack_public_path__ + "img/yml_gallery16.2ed9b58e.jpg";